import React from 'react';
import { Branch } from 'store/space/type';
import LocalStitchMap from 'components/common/LocalStitchMap';
import { LatLng } from 'constants/type';

interface IProps {
  closeModal: () => void;
  branch: Branch;
}

const ModalMapPopup: React.FC<IProps> = ({ closeModal, branch }: IProps) => {
  const mapCenter: LatLng = {
    lat: Number(branch.latitude),
    lng: Number(branch.longitude),
  };

  return (
    <div className="dimd-layer">
      <div className="inner n-pad">
        <section className="pop-spot">
          <LocalStitchMap center={mapCenter} branches={[branch]} zoom={16} />
          <div className="map-w" style={{ marginTop: 0, paddingBottom: 30 }} />
          <button type="button" className="btn-close" onClick={closeModal}>
            <span>팝업 닫기</span>
          </button>
        </section>
      </div>
    </div>
  );
};

export default ModalMapPopup;
